import { memo } from "react";

import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import { CategorySection, MainSection } from "./components";

type Props = {
	hostContents: SearchedContent;
	guestContents: SearchedContent;
};

export const SearchedContents = memo(({ hostContents, guestContents }: Props) => {
	return (
		<div className="relative flex w-full space-x-8">
			{/* メイン */}
			<MainSection hostContents={hostContents} guestContents={guestContents} />

			{/* カテゴリ */}
			<CategorySection hostContents={hostContents} guestContents={guestContents} />
		</div>
	);
});
